<template>
<div class="iframe" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
	<iframe ref="IframeOutLink" class="outlink" allowfullscreen='true' :src="src" frameborder="0"></iframe>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "outlink",
	data(){
		return{
			src: "",
			path: this.$route.path,
			loading: false
		}
	},
	computed: {
		...mapGetters([
			'permission_menus',
			'token'
		]),
	},
	mounted(){
		this.setIframeUrl();
	},
	methods: {
		setIframeUrl(){
			this.loading = true;
			const path = this.path;
            let url = "";
            findUrl(this.permission_menus);
            if(url){
				// 添加token到url中
				if(this.token){
					let search = `auth-token=${this.token}`;
					url += url.indexOf("?")>-1?"&":"?";
					url += search;
				}
				this.src = url;
				const iframe = this.$refs.IframeOutLink;
				console.log(iframe)
				if (iframe.attachEvent) {
					iframe.attachEvent("onload", () => {
						this.loading = false;
					});
				} else {
					iframe.onload = () => {
						this.loading = false;
					};
				}
            }

            function findUrl(nodes){
                for(let node of nodes){
					if(node.menuUrl == path){
						url = node.viewUrl;
					}
                    findUrl(node.nodes);
                }
            }
        }
	}
}
</script>

<style lang="scss" scoped>
.iframe,.outlink{
	width: 100%;
	height: 100%;
}
.outlink{
	border: none;
	padding: 8px;
}
</style>